import { apiClient } from "./api-client";
import type {
  CreateEventRequest,
  FamilyEvent,
  UpdateEventRequest,
  UpcomingEvents,
} from "../types/event";

interface ApiResponse<T> {
  data: T;
}

function nearestFirst(left: FamilyEvent, right: FamilyEvent): number {
  return left.date.localeCompare(right.date) || left.id.localeCompare(right.id);
}

export function getEvents(): Promise<FamilyEvent[]> {
  return apiClient
    .get<ApiResponse<FamilyEvent[]>>("/events")
    .then((response) => [...response.data].sort(nearestFirst));
}

export function getEvent(id: string): Promise<FamilyEvent> {
  return apiClient
    .get<ApiResponse<FamilyEvent>>(`/events/${id}`)
    .then((response) => response.data);
}

export function getUpcomingEvents(): Promise<UpcomingEvents> {
  return apiClient
    .get<ApiResponse<UpcomingEvents>>("/events/upcoming")
    .then((response) => response.data);
}

export function createEvent(
  request: CreateEventRequest,
): Promise<FamilyEvent> {
  return apiClient
    .post<ApiResponse<FamilyEvent>>("/events", request)
    .then((response) => response.data);
}

export function updateEvent(
  id: string,
  request: UpdateEventRequest,
): Promise<FamilyEvent> {
  return apiClient
    .patch<ApiResponse<FamilyEvent>>(`/events/${id}`, request)
    .then((response) => response.data);
}

export function deleteEvent(id: string): Promise<void> {
  return apiClient.delete<void>(`/events/${id}`);
}
